import * as React from 'react'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import '../css/platform.css'
import AppProps from '../util/appProps'
import {ACCENT_TEXT_FW500, tagger, setTitleFont} from '../util/util'

interface PlatformBlock {
    show: boolean
    title: string
    text: string
    button: string
    image: string
    termsText: string
    policyText: string
    policyLink: string
    welcomeUrl: string
    finishUrl: string
}

const Welcome = (props: AppProps) => {

    const [isBack, setIsBack] = useState(false)

    const tC = useTranslation('common').t
    const {t, i18n} = useTranslation('welcome')

    useEffect(() => {
        setIsBack(props.location.pathname.includes('/welcomeBack'))
        setTitleFont(i18n.language)
    }, [])

    const platformBlocks = [
        {
            show: true,
            title: t('Im a Developer'),
            text: t('Use our SDK/API'),
            button: tC('Integrate Now'),
            image: 'https://static.persona.ly/images/platform/rtb-icon-01.svg',
            termsText: t('By clicking the Integrate Now'),
            policyText: t('and SDK Privacy Policy'),
            policyLink: 'privacy_sdk',
            welcomeUrl: 'https://sdk.persona.ly/cms/api/user/signUp/sdk/',
            finishUrl: 'https://sdk.persona.ly/cms/api/user/urlPart/sdk/'
        },
        {
            show: !isBack,
            title: t('Im an Advertiser'),
            text: t('Grow your audience'),
            button: tC('Contact Us'),
            image: 'https://static.persona.ly/images/platform/ch-01.svg',
            termsText: t('By clicking the Contact Us'),
            policyText: t('and Privacy Policy'),
            policyLink: 'privacy_policy',
            welcomeUrl: 'getInTouch?id=',
            finishUrl: undefined
        },
        {
            show: true,
            title: t('Im a Publisher'),
            text: t('Gain access to'),
            button: tC('Start Now'),
            image: 'https://static.persona.ly/images/platform/group-15.svg',
            termsText: t('By clicking the Start Now'),
            policyText: t('and DSP Privacy Policy'),
            policyLink: 'privacy_dsp',
            welcomeUrl: 'https://sdk.persona.ly/cms/api/user/signUp/dsp/',
            finishUrl: 'https://sdk.persona.ly/cms/api/user/urlPart/dsp/'
        },
        {
            show: !isBack,
            title: t('Im a Website Owner'),
            text: t('Implement our offer wall'),
            button: tC('Integrate Now'),
            image: 'https://static.persona.ly/images/platform/group-16.svg',
            termsText: t('By clicking the Integrate Now'),
            policyText: t('and SDK Privacy Policy'),
            policyLink: 'privacy_sdk',
            welcomeUrl: 'https://sdk.persona.ly/cms/api/user/signUp/sdk/',
            finishUrl: undefined
        }
    ]

    const signUpRedirect = (block: PlatformBlock) => {
        const search = props.location.search
        const params = new URLSearchParams(search)

        if (isBack) {
            const token = params.get('token')
            const type = params.get('type')
            if (token && type) {
                let urlPart
                switch (type) {
                    case 'signin':
                        urlPart = 'signInFinish'
                        break
                    case 'forgot':
                        urlPart = 'forgotPasswordFinish'
                        break
                }
                window.location.href = block.finishUrl.replace('urlPart', urlPart) + token
            }
        } else {
            const userId = params.get('id')
            if (userId) {
                window.location.href = block.welcomeUrl + userId
            }
        }
    }

    const renderPlatformBlock = (block: PlatformBlock, i) => block.show && (
        <div key={i} className="platform-block">
            <div className="platform-image"><img className="platform-image" src={block.image} /></div>
            <div className="title muli">{tagger(block.title, 'accent-text')}</div>
            <div className="text">{tagger(block.text, 'accent-text')}</div>
            <button onClick={() => signUpRedirect(block)} className="button-blue large button">{block.button}<img src="https://static.persona.ly/images/arrow.svg" /></button>
            <div className="platform-policy">
                {tagger(block.termsText, ACCENT_TEXT_FW500, 'terms_use')} {tagger(block.policyText, ACCENT_TEXT_FW500, block.policyLink)}
            </div>
        </div>
    )

    return (
        <div className="common-pages-container" style={{padding: '14% 0 0 0', textAlign: 'center'}}>
            <p className="title muli">{isBack ? t('welcome back') : tagger(t('welcome to'), 'accent-text')}</p>
            <div className="text">{t(isBack ? 'to start please 2' : 'to start please 1')}</div>
            <div className="platform-container">
                <div className="platform-container">{platformBlocks.slice(0, 2).map(renderPlatformBlock)}</div>
                <div className="platform-container">{platformBlocks.slice(2, 4).map(renderPlatformBlock)}</div>
            </div>
        </div>
    )
}

export default Welcome


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/welcome.tsx